(function() {

    var selectors = {
        submitButton: '[data-uec-submit-button]',
        form: '[data-uec-form]',
        spinner: '#absolute-center-spinner',
        container: '[data-your-details-container]',
        generalError: '[data-uec-general-error]',
        networkSelect: '[data-network-selection]',
        networkSelectCmsForBlackList: '[data-network-selection-cms-black-list]',
        networkSelectCmsForSkipUecCallList: '[data-network-selection-cms-skip-uec-call-list]',
        mobileDetailsSubmit: '[data-mobile-details-submit]'
    };

    var selectedNetworkCmsForSkipUecCallList = $(selectors.networkSelectCmsForSkipUecCallList).data('networkSelectionCmsSkipUecCallList');

    $(document).on('submit', selectors.form, function(event) {
        event.preventDefault();
        var formSerialize = $(this).serialize();

        $(selectors.spinner).removeClass('hide');
        $(selectors.generalError).addClass('hide');

        $.post({
            url: $(selectors.form).data('uec-endpoint'),
            data: formSerialize,
            success: processUecResponse
        });
    });

    $(document).on('change', selectors.networkSelect, function() {
        var selectedNetworkCmsForBlackList = $(selectors.networkSelectCmsForBlackList).data('networkSelectionCmsBlackList');
        var mobileDetailsSubmit = $(selectors.mobileDetailsSubmit);
        var selectedNetwork = $(this).children('option:selected').val().toLowerCase();
        var hideClass = 'hide';
        var selectedNetworkCss = 'data-network-selection-cms-' + selectedNetwork;
        var selectedNetworkCssElement = '[' + selectedNetworkCss + ']';
        var selectedNetworkCmsForBlackListArray = selectedNetworkCmsForBlackList.split(', ');
        hideNetworkCmsContent(selectedNetworkCmsForBlackListArray);
        if ($.inArray(selectedNetwork, selectedNetworkCmsForBlackListArray) === -1) {
            showSkipUecCallCmsContent(selectedNetwork);
            mobileDetailsSubmit.prop('disabled', false);
        } else {
            hideSkipUecCallCmsContent();
            if (($.inArray(selectedNetwork, selectedNetworkCmsForBlackListArray) !== -1) && $(selectedNetworkCssElement).hasClass(hideClass)) {
                $(selectedNetworkCssElement).removeClass(hideClass);
                mobileDetailsSubmit.prop('disabled', true);
            } else if (!$(selectedNetworkCssElement).hasClass(hideClass)) {
                $(selectedNetworkCssElement).addClass(hideClass);
                mobileDetailsSubmit.prop('disabled', false);
            }
        }
    });

    var processUecResponse = function(data) {
        $(selectors.spinner).addClass('hide');
        var queryString = '';
        var statusArray = new Array('success', 'info');
        if ($.inArray(data.status, statusArray) !== -1) {
            queryString = '?earlyUpgradeFee=' + data.earlyUpgradeFee;
            queryString += '&upgradeEligibleDate=' + data.upgradeEligibleDate;
            queryString += '&upgradeTypesAllowed=' + data.upgradeTypesAllowed;
            queryString += '&network=' + data.network;
            queryString += '&status=' + data.status;
            window.location = $(selectors.submitButton).data('uec-results-end-point') + queryString;
        } else if (data.status === 'error') {
            $(selectors.container).html(data.html);
            state.addressType = 'lookup';
            renderView();
            $('.checkbox input:checkbox:checked').parent().addClass('checked');
            $('.smp-input input:radio:checked').parent().addClass('active');
        } else if (data.status === 'failure' && data.errorCode === 'uec-session-timeout') {
            window.location = $(selectors.form).data('uec-restart-path');
        } else if ((data.status === 'failure' && data.errorCode === 'uec-general-error') || typeof data.status == 'undefined') {
            $(selectors.spinner).addClass('hide');
            $(selectors.generalError).removeClass('hide');
        } else {
            var status = data.status ? data.status : 'failure';
            queryString = '?status=' + status + '&errorCode=' + data.errorCode;
            window.location = $(selectors.submitButton).data('uec-results-end-point') + queryString;
        }
    };

    var hideNetworkCmsContent = function(selectedNetworkCmsForBlackListArray) {
        selectedNetworkCmsForBlackListArray.forEach(function(network) {
            var selectedNetworkCss = 'data-network-selection-cms-' + network;
            var selectedNetworkCssElement = '[' + selectedNetworkCss + ']';
            $(selectedNetworkCssElement).addClass('hide');
        });
    };

    var showSkipUecCallCmsContent = function(selectedNetwork) {
        var selectedNetworkCss = 'data-skip-tibco-call-network-selection-cms-' + selectedNetwork;
        var selectedNetworkCssElement = '[' + selectedNetworkCss + ']';
        var hideClass = 'hide';
        var selectedNetworkCmsForSkipUecCallArray = selectedNetworkCmsForSkipUecCallList.split(', ');
        hideSkipUecCallCmsContent();
        if (($.inArray(selectedNetwork, selectedNetworkCmsForSkipUecCallArray) !== -1) && $(selectedNetworkCssElement).hasClass(hideClass)) {
            $(selectedNetworkCssElement).removeClass(hideClass);
        } else if (!$(selectedNetworkCssElement).hasClass(hideClass)) {
            $(selectedNetworkCssElement).addClass(hideClass);
        }
    };

    var hideSkipUecCallCmsContent = function() {
        var selectedNetworkCmsForSkipUecCallArray = selectedNetworkCmsForSkipUecCallList.split(', ');
        selectedNetworkCmsForSkipUecCallArray.forEach(function(network) {
            var selectedNetworkCss = 'data-skip-tibco-call-network-selection-cms-' + network;
            var selectedNetworkCssElement = '[' + selectedNetworkCss + ']';
            $(selectedNetworkCssElement).addClass('hide');
        });
    };
})($);
